import http from '@core/fetch'

export default {
  getInfo: body =>
    http('/p/wedding/Admin/APIMealRelation/SampleInfo', { body }), // 获取信息
  getRelationImg: body =>
    http('/p/wedding/index.php/Admin/APIMealRelation/RelatedWorkList', {
      body
    }), // 获取关联客照
  getSelectImg: body =>
    http('/p/wedding/index.php/Admin/APIMealRelation/WorkList', { body }), // 获取可选客照
  addRelation: body =>
    http.post('/p/wedding/index.php/Admin/APIMealRelation/AddRelation', {
      body
    }), // 添加关联客照
  reOrder: body =>
    http.post('/p/wedding/index.php/Admin/APIMealRelation/Reorder', { body }), // 关联客照排序
  cancelRelation: body =>
    http.post('/p/wedding/index.php/Admin/APIMealRelation/CancelRelation', {
      body
    }) // 取消客照关联
}
